<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
    width: 100%;
    font-size: 15px;
  }
  .el-pager li{
    height: 40px !important;
    line-height: 40px !important;
  }
  .all{
    position:absolute;
    left:0;
    top:0;
    right:0;
    bottom:0;
    overflow-y:scroll;
    overflow-x:hidden;
  }
  * {
    margin: 0;
    padding: 0;
  }
  html, body {
    height: 100%;
    width: 100%;
  }
  ul li{
    list-style-type:none;
  }
  /* input不要箭头*/
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
  table{
    border-collapse:collapse;

  }
  /*.el-input--suffix .el-input__inner{*/
    /*height: 40px;*/
  /*}*/
  .el-input__inner{
    height: 40px !important;
  }
  .btn-prev,.btn-next{
    height: 40px !important;
  }

  .sousuo{
    width:316px;
    display: flex;
    margin-left: 25px;
  }
  .sousuo_span{
    height:14px;font-size:14px;font-weight:400;color:rgba(144,147,153,1);line-height:14px;
  }
  .sousuo_n{
    width: 20px; height:14px;font-size:14px;font-weight:400;color:rgba(144,147,153,1);line-height:14px;
  }
  .newText{
    display: flex;
    margin-left: 25px;
    font-size: 18px;
    margin-right: 23px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153,153,153,1);
    align-items: center;
    cursor: pointer;
  }

  .head_div_all{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
  }
  .newText:hover{
    color: #595b5f;
  }
  .list_date{
    font-size:18px;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    color:rgba(34,119,239,1);
  }
  .table_all_div{
    margin:30px 25px 0px 25px;
    background-color: white;
    padding-left: 22px;
    padding-right: 22px;
  }
  .el-main{
    position:relative;
    height:100%;
  }
  .el-pagination button, .el-pagination span{
    height: 40px !important;
    line-height: 40px !important;
  }
  .el-checkbox{
    margin-left: 2px;
  }
  .listofall{
    display: flex;justify-content: space-between
  }
  .list_date_head{
    display:inline-block;margin:21px 0 0 23px;
  }
  .list_date_span{
    display:inline-block;margin:5px 0 0 23px;font-size: 10px;color: silver
  }
  .listofall_two{
    margin-left: 1%;
    display: flex;
    align-items: center;
    margin-top: 21px;
    width: 30%;
    justify-content: space-between
    ;
  }
  .listofall_two_input{
    width:316px;
    height:38px;
    background:rgba(241,241,241,1);
    font-size:14px;
    font-weight:400;
    border: 1px solid #dcdfe6;
    color:rgba(85,85,85,1);
  }
  .listofall_two_img{
    width:60px;
    height:40px;
    border: none;
  }
  .fenye{
    margin-top: 29px;
    width: 100%;
    margin-bottom: 30px;
  }
  .el-menu{
    border: 0;
  }
  /*指针变手*/
  .cursor:hover{
    cursor:pointer;
  }
  .el-dialog__headerbtn{
    visibility: hidden !important;
  }

  .tooltip{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
  }
  .tooltip_img{
    width:344px;
    height:324px;
  }
  .tooltip_span{
     color: #999999;
    font-size:18px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    line-height:25px;
  }
  .ttt td{
    font-size: 14px;
  }

  .el-submenu__title:hover{
    background-color:  rgb(36, 37, 54) !important;
  }

  .el-menu-item ,.is-active{
    background-color:transparent !important;
  }
  .el-menu-item,.el-submenu__title{
    text-align: left!important;
  }
  .el-checkbox__label{
    width: 120px;
    text-align: left;
  }
  .btn-gray {
    color:#FFFFFF;
    font-weight:bold;
    background: #E6E6E6;
  }
  .btn-high-light-blue {
    color:rgb(255, 255, 255);
    font-weight:bold;
    background: rgb(59, 153, 241);
  }
  .el-checkbox__inner{
  border:1px solid #555 !important;/*输入框*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue